import { render, staticRenderFns } from "./ChoicesList.vue?vue&type=template&id=117786b9&"
import script from "./ChoicesList.vue?vue&type=script&lang=js&"
export * from "./ChoicesList.vue?vue&type=script&lang=js&"
import style0 from "./ChoicesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports